/* eslint-disable no-console */
/* eslint-disable no-undef */
// Esse arquivo serve pra redirecionar as chamadas para o Core real, usando a variavel global do ambiente:

const isBrowser = () => {
  try {
    return !!window;
  } catch (e) {
    return false;
  }
};

const getGlobalContext = () => {
  let context = null;
  try {
    if (isBrowser()) {
      context = window['__CoreContext'];
    } else {
      context = global['__CoreContext'];
    }
    // acumula a versão do core-defs no Bundle
    if (
      context.Utils &&
      context.Utils.accumulateVersions &&
      typeof context.Utils.accumulateVersions === 'function'
    ) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const Package = require('./package.json');
      context.Utils.accumulateVersions(Package.version);
    }
  } catch (e) {
    console.error(
      "__CoreContext not found. Have you added `import '@smiles/core-engine'` in your index file?",
      e,
    );
  }
  return context;
};

const createProxy = (prop) => {
  // propositalmente o getGlobalContext é chamado em cada passagem/operação, não pode ser deslocado.
  return {
    get: (_, sKey) => {
      // valida se o contexto já existe ou se o hot reload está procurando por marcadores dele como $$typeof
      const context = getGlobalContext();
      if (context === null || context === undefined || sKey === '$$typeof')
        return null;
      if (context[prop])
        return context[prop][sKey] || context[prop].getItem(sKey);
      return undefined;
    },
    getOwnPropertyDescriptor: () => {
      return { enumerable: true, configurable: true };
    },
    ownKeys: (_target) => {
      const context = getGlobalContext();
      if (context === null || context === undefined) return [];
      return Reflect.ownKeys(_target);
    },
    has: (_, sKey) => {
      const context = getGlobalContext();
      if (context === null || context === undefined) return false;
      return (
        sKey in getGlobalContext()[prop] ||
        getGlobalContext()[prop].hasItem(sKey)
      );
    },
  };
};

// Stubs / Proxy para os objetos reais...
const Bundle = new Proxy({}, createProxy('Bundle'));
const Mocks = new Proxy({}, createProxy('Mocks'));
const Helpers = new Proxy({}, createProxy('Helpers'));
const Config = new Proxy({}, createProxy('Config'));
const Utils = new Proxy({}, createProxy('Utils'));
const EventsLogger = new Proxy({}, createProxy('EventsLogger'));
const Logger = new Proxy({}, createProxy('Logger'));

module.exports = {
  Bundle,
  Mocks,
  Helpers,
  Config,
  Utils,
  EventsLogger,
  Logger,
};
